import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import Attention from "../../components/Attention";
import Button from "../../components/Buttons/Button";
import Details from "../../components/DifficultComponents/Details";
import GoToBackArrow from "../../components/GoToBackArrow";
import Input from "../../components/Inputs/Input";
import ServiceComponent from "../../components/DifficultComponents/ServiceComponent";
import Consent from "../../components/Сonsent";
import "./index.css";
import {API_BASE_URL} from "../../config";
import InputMask from 'react-input-mask';

const ConfirmationPage = () => {
    const navigate = useNavigate();
    const telegramUser = JSON.parse(sessionStorage.getItem('telegramUser') || '{}');
    const telegramUserId = Number(sessionStorage.getItem('telegramUserId'));

    const duration = localStorage.getItem('duration');
    const [name, setName] = useState(
        [telegramUser?.first_name, telegramUser?.last_name].filter(Boolean).join(' ')
    );
    const [phone, setPhone] = useState("");
    const [comment, setComment] = useState("");
    const [agree, setAgree] = useState(false);

    const [error, setError] = useState(false)

    const [offer, setOffer] = useState()
    const orderId = localStorage.getItem('orderId');
    const mode = localStorage.getItem('mode');

    /**
     *
     * @type {React.MutableRefObject<HTMLInputElement>}
     */
    const phoneRef = useRef(null);

    useEffect(() => {
        const serviceId = localStorage.getItem('serviceId')
        if (serviceId) {

            fetch(API_BASE_URL + "/api/offers", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"  // Используется для отправки куков при необходимости
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok " + response.statusText);
                    }
                    return response.json();
                })
                .then(data => {
                    setOffer(data.find(elem => elem.id == serviceId))
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                });
        }
    }, [])

    const handleSubmit = async () => {
        if (mode !== 'edit' && !agree) {
            setError(true)
            return
        }
        setError(false)

        if (phoneRef.current && !phoneRef.current.reportValidity()) {
            return;
        }

        const time = localStorage.getItem('time')
        const day = localStorage.getItem('day')
        const expertId = localStorage.getItem('expertId')
        const serviceId = localStorage.getItem('serviceId')

        const requestBody = {
            "specialist_id": +expertId,
            "service_id": +serviceId,
            "client_telegram_id": telegramUserId || 927836,
            "booking_date": day,
            "booking_start_time": time,
        }

        if (!orderId) {
            requestBody.client_name = name;
            requestBody.client_phone = phone;
            requestBody.comment = comment;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/order/book/${orderId ? `${orderId}/` : ''}`, {
                method: "POST", headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Booking successful", data);
                navigate("/order-details");
            } else if (data.error) {
                alert(data.error)
            } else {
                const errorDetails = await response.json();
                console.error("Booking failed", response.statusText, errorDetails);
                alert('Запись на это время уже недоступна')
            }
        } catch (error) {
            console.error("Error during booking", error);
        }
    };

    return (
        <div className="confirmation_page page_bg">
            <GoToBackArrow/>
            <div className="content_title">
                <span>Детали записи</span>
            </div>
            <div className="details_list">
                <Details type={"expert"} img={"pencil"}/>
                <Details type={"time"} img={"pencil"}/>
            </div>
            <div className="content_title">
        <span>
          Услуги <span>· {duration ? duration : ""}</span>
        </span>
            </div>
            <ServiceComponent
                title={offer?.name}
                duraion={offer?.duration}
                price={offer?.cost}
                img={"pencil"}
                chosenService={offer?.name}
            />
            {mode !== 'edit' && (
                <>
                    <div className="content_title">
                        <span>Ваши данные</span>
                    </div>
                    <form className="form">
                        <Input placeholder={"Имя"} value={name} onChange={(e) => setName(e.target.value)}/>
                        <InputMask
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder={"Номер телефона"}
                            mask="+7 (999) 999-99-99"
                            className="ui_input"
                            value={phone}
                            type={'tel'}
                            name="phone"
                            required
                            inputRef={(input) => {
                                phoneRef.current = input
                            }}
                        />
                        <Input placeholder={"Комментарий к записи"} value={comment}
                               onChange={(e) => setComment(e.target.value)}/>
                    </form>
                    <Consent handleChangeAgree={(value) => setAgree(value)} agree={agree} error={error}/>
                    <Attention/>
                </>
            )}
            <Button onClick={handleSubmit}>
                {mode === 'edit' ? 'Сохранить' : 'Записаться'}
            </Button>
        </div>
    );
};

export default ConfirmationPage;
